import React, { useState } from 'react';
import ConversorGNDI from './ConversorGNDI';
import ConversorQUALI from './ConversorQUALI';

const ConversorUniversal = () => {
  const [tipo, setTipo] = useState('');

  return (
    <div className="container">
      <h1>Conversor Universal</h1>
      <div className="button-group" style={{ marginBottom: 24 }}>
        <button
          className={tipo === 'gndi' ? 'button active' : 'button'}
          onClick={() => setTipo('gndi')}
        >
          Converter GNDI
        </button>
        <button
          className={tipo === 'quali' ? 'button active' : 'button'}
          onClick={() => setTipo('quali')}
        >
          Converter Qualicorp
        </button>
      </div>
      {tipo === '' && <p>Selecione o tipo de arquivo que deseja converter.</p>}
      {tipo === 'gndi' && <ConversorGNDI />}
      {tipo === 'quali' && <ConversorQUALI />}
    </div>
  );
};

export default ConversorUniversal; 